<!--====================================
=            LAYOUTVERTICAL            =
=====================================-->
<template>
  <div>
    <!-- SYSTEM BAR-->
  
    <!--drawer vertical  -->
    <v-navigation-drawer :class="$vuetify.theme.dark ? 'card-dark' : 'card-light'" v-model="drawer"
                         style="height:1200px;" app hide-overlay>
      <perfect-scrollbar>
        <drawer-vertical></drawer-vertical>
      </perfect-scrollbar> <template v-slot:append>
        <div class="pa-2">
          <v-btn @click="gohome()" :class="$vuetify.theme.dark ? 'card-dark' : 'card-light'" class="white--text" block>
            <v-icon>logout</v-icon> Logout
          </v-btn>
        </div>
      </template>
    </v-navigation-drawer>
    <!--drawer right -->
    <v-navigation-drawer v-model="drawerRight" :class="$vuetify.theme.dark ? 'card-dark' : 'card-light'" temporary fixed class="  d-print-none mx-auto" :right="!$vuetify.rtl">
      <base-settings></base-settings>
    </v-navigation-drawer>
     <!--main -->
   <v-main  :class="$vuetify.theme.dark ? 'dark' : 'light'">
      <!-- Provides the application the proper gutter -->
      <v-container class="transparent mb-10">
        <!-- If using vue-router -->
         <sequential-entrance>  <router-view></router-view>  </sequential-entrance>
        <v-btn @click.stop="drawerRight=!drawerRight" class=" product-upgrade-to-pro error">
          <v-icon size="30" dark> settings
          </v-icon>
        </v-btn>
      </v-container>
    </v-main>
    <!-- footer-->
    <base-footer></base-footer>
  </div>
</template>

<script>
  import {
    PerfectScrollbar
  } from "vue2-perfect-scrollbar";
  import DrawerVertical from '../components/Drawer/DrawerVertical'
  import BaseSettings from '../components/Base/BaseSettings'
  import BaseFooter from '../components/Base/BaseFooter'
  export default {
    components: {
      PerfectScrollbar,
      BaseSettings,
      DrawerVertical,
      BaseFooter
    },
    data() {
      return {
        drawerRight: false,
        sidebarMenu: true,
        drawer: true,
        searchActive: false,
        align: 'center',
      }
    },
    methods: {
      gohome() {
        return this.$router.push("/");
      },


    },
  }
</script>

<style>
   .light {
    background-image: url('../assets/images/bg/5.jpg'); 
    background-size: 100%
  }

  .dark {
    background-image: url('../assets/images/bg/dark.jpg');

    background-size: 100%
  }

  .card-light {
    border-radius: 1em;
    border: 1px solid rgba(255, 255, 255, 0.5) !important;
    text-shadow: 0 0 1em rgba(0, 0, 0, 0.5) !important;
    background: rgba(255, 255, 255, 0.2) !important;
    -webkit-backdrop-filter: blur(20px) !important;
    backdrop-filter: blur(20px) !important;
    transform: perspective(500px) !important;
    transform-style: preserve-3d !important;
  }

  .card-dark {
    border-radius: 1em;
    border: 1px solid rgba(0, 0, 0, 0.5)!important;
    text-shadow: 0 0 1em rgba(245, 245, 245, 0.5)!important;
    background: rgba(0, 0, 0, 0.2)!important;
    -webkit-backdrop-filter: blur(20px)!important;
    backdrop-filter: blur(20px)!important;
    transform: perspective(500px)!important;
    transform-style: preserve-3d!important;
  }

  .ps {
    height: 100%
  }

  .v-navigation-drawer__content {
    height: 100%;
    overflow-y: hidden;
    overflow-x: hidden;
  }
</style>


<style lang="scss" scoped>
  .product-upgrade-to-pro {
    z-index: 4;
    top: 50%;
    right: 1px;
    position: fixed;

    .v-application &.v-btn.v-btn--is-elevated {
      box-shadow: 0 1px 20px 1px #ff4c51 !important;

      &:hover {
        box-shadow: none !important;
      }
    }
  }
</style>


<!--====  End of LAYOUTVERTICAL  ====-->